import React from 'react';
import VerticalFilter from '../../components/VerticalFilter';

export const ParticipantFilterExpansionPanel = (props: any) => {
  const applyFilter = (values: any) => {
    props.onSubmit(values);
  };

  const resetFilter = () => {
    props.onReset();
  };

  return (
    <div>
      <VerticalFilter
        data-id="participant-filter-comp"
        filterConfig={props.filterDataConfig}
        applyFilter={applyFilter}
        resetFilter={resetFilter}
        filterCriteria={props.defaultFilter}
        closeFilter={props.closeFilter}
        participantTypeData={props.participantTypeData}
        workflowList={props?.workflowList}
      />
    </div>
  );
};
export default ParticipantFilterExpansionPanel;
